export default function debounce<TParams, TReturn>(
  fn: (...params: TParams[]) => TReturn,
  time: number
) {
  let timerId: ReturnType<typeof setTimeout> | undefined = undefined;

  return [function (...args: TParams[]) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => fn(...args), time);
  }, function () {
    if (timerId) {
      clearTimeout(timerId);
    }
  }]
}

export function debouncePromise<T>(time: number): [(value: T) => Promise<T>, () => void] {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const cancel = () => clearTimeout(timer);
  const debounced = (value: T) => {
    cancel();
    return new Promise<T>((resolve) => {
      timer = setTimeout(() => resolve(value), time);
    });
  };
  return [debounced, cancel];
}
